<template>
    <v-row>
        <v-col cols="12">
            <FileUploader
                    v-model="value"
                    :field-id="field.id"
                    :stencil="field.photo.stencil_url"
                    :multiple="field.photo.multiple"
                    :gallery="gallery"
                    :type="field.photo.type"
                    @loading="loading" />
            <v-col
                    cols="12"
                    class="mt-0 pt-0">
                <v-messages
                        v-if="errorState"
                        color="error"
                        :value="[error]" />
            </v-col>
        </v-col>
    </v-row>
</template>

<script>
    import Value from "../../../../../models/value.model";
    import FileUploader from "../../../../FileUploader";
    import Field from "@/models/field.model";

    export default {
        name: "FieldPhotoComponent",
        components: {FileUploader},
        props: {
            field: {type: Object, default: () => new Field()},
        },
        data() {
            return {
                value: null,
                error: null,
            }
        },
        computed: {
            gallery() {
                return (this.field.photo.show_consumer_gallery) ? this.field.photo.gallery : []
            },
            errorState() {
                return !!this.error;
            }
        },
        watch: {
            value() {
                this.getValue().then((value) => {
                    this.$emit('updateValue', value);
                })
            }
        },
        mounted() {
            this.value = this.field.value.value;
        },
        methods: {
            loading: function (value) {
                this.$emit('loading', value)
            },
            /**
             *
             * @returns {Value}
             */
            async getValue() {
                const value = new Value({
                    value: this.value,
                    isValid: true
                });
                
                if (!this.field.is_optional && value.isEmpty) {
                    this.error = 'Mandatory field';
                } else {
                    this.error = null;
                }

                if (this.error) {
                    value.isValid = false;
                    value.error = this.error;
                }
                
                return value;
            },
            isValid() {
                return true;
            },
        }
    }
</script>

<style scoped>
	.maz-input__input {
		height: 56px !important;
	}
</style>